<template>
  <view-page
      baseRoute="facilities.markets"
      :entity='entity'
      :button-access="componentAccess"
      :model-entity="modelEntity"
      :model-id="$route.params.marketId"
  >
    <template v-slot="{model}">
      <market-form
          :readonly="readonly"
          v-model="model"
          ref="form"
          :loading="loading"
          :card-title="model.MarketName ? `Market: ${model.MarketName}` : 'Market:'"
      />
    </template>

    <template v-slot:extra-button="{ model }">
      <vs-button
          v-if="model"
          class="mt-2 ml-4"
          color="light"
          @click="openEnableAlert(model)"
      >
        {{ model.IsEnabled ? "Deactivate" : "Activate" }}
      </vs-button>
    </template>
  </view-page>
</template>

<script>

import MarketForm from '@/views/pages/facilities/markets/MarketForm';
import ViewPage from '../../../components/Views/ViewPage';
import NotificationMixin from '../../../../components/mixins/NotificationMixin';
import EnablePublishMixin
  from '../../../../components/mixins/EnablePublishMixin';

export default {
  name: "MarketEdit",
  components: {
    MarketForm,
    ViewPage,
  },
  mixins: [NotificationMixin, EnablePublishMixin],
  data() {
    return {
      readonly: true,
      loading: false,
      modelEntity: this.$api.facilities.markets,
      entity: 'Market',
      componentAccess: {
        canEdit: {
          route: 'facilities.markets.edit',
          access: false,
        },
        canDelete: {
          route: 'facilities.markets.delete',
          access: false,
        },
      }
    };
  },
  methods: {
    getParams() {
      const params = this.getModelCopy(true);
      this.setDates(['InceptionDate', 'ExpiryDate'])

      delete params.Facility_FK;

      return params;
    },
  },
};
</script>
